import { taskAPI } from '@/utils/api';

const MAX_IPE_TASK_ID_LEN = 64;

/** 工作流内 funding_task.task_id：条目 + 本轮 runId + 随机后缀，避免并发/重入撞 uk_funding_task_task_id */
export function buildWorkflowIpeTaskId(prefix, rowId, workflowRunId) {
  const rid = String(rowId ?? '0').trim().slice(0, 20) || '0';
  const run = workflowRunId != null ? String(workflowRunId) : String(Date.now());
  const nonce = Math.random().toString(36).slice(2, 6);
  let id = `${prefix}-wf-${rid}-${run}-${nonce}`;
  if (id.length <= MAX_IPE_TASK_ID_LEN) return id;
  const suffix = `-${nonce}`;
  const headLen = MAX_IPE_TASK_ID_LEN - suffix.length;
  return `${id.slice(0, headLen)}${suffix}`;
}

export function isDuplicateIpeTaskIdError(err) {
  const status = Number(err?.status);
  if (status === 409) return true;
  const code = String(err?.code || err?.payload?.code || '').toUpperCase();
  if (code === 'DUPLICATE_TASK_ID' || code === 'DATA_CONFLICT') return true;
  const msg = String(
    err?.rawMessage || err?.message || err?.payload?.message || err?.data?.message || err || '',
  );
  return /Duplicate entry/i.test(msg)
    || /uk_funding_task_task_id/i.test(msg)
    || /任务编号已存在/i.test(msg)
    || (/task_id/i.test(msg) && /duplicate|unique|已存在/i.test(msg));
}

/**
 * 创建 funding 任务；若 task_id 已存在（双开执行/重试）则重置为 processing 继续，避免 SQL 唯一键错误。
 */
export async function createIpeWorkflowTask(payload) {
  const id = payload?.id;
  if (!id) {
    await taskAPI.create(payload);
    return;
  }
  try {
    await taskAPI.create(payload);
  } catch (err) {
    if (!isDuplicateIpeTaskIdError(err)) throw err;
    await taskAPI.update(id, {
      type: payload.type,
      name: payload.name,
      title: payload.title,
      subAccount: payload.subAccount,
      billingNavId: payload.billingNavId,
      status: payload.status || 'processing',
      total: payload.total ?? 1,
      successCount: payload.successCount ?? 0,
      failedCount: payload.failedCount ?? 0,
      imageIds: payload.imageIds,
      presetId: payload.presetId,
      result: payload.result,
    });
  }
}
